/*
 * 記事の「よくあるご質問」を開閉式に組み直す
 *
 * 仕組み:
 *   article.content の文字列を切り貼りせず、描画後の DOM を走査する。
 *   依存するのは「H2 と H3 で区切られている」という構造だけなので、
 *   答えが 1 段落でも 3 段落でも、リストや画像が挟まっても正しく動く。
 *
 * 契約:
 *   - FAQ セクションの H2 は data-faq-markers のいずれかを含む（既定「よくあるご質問」）
 *   - FAQ の範囲は、その H2 から次の H2 の直前まで
 *   - ただし NON_CONTENT_CLASSES の要素が現れたらそこで終わる（本文の外側の挿入物）
 *   - 範囲内の H3 が設問、H3 から次の H3 までが答え
 *
 * サーバーが返す HTML には H3 と段落がそのまま残るため、
 * JS を実行しない AI クローラは可視テキストとして読める。
 *
 * 関連: .company/engineering/shopify/article-toc-faq-rebuild-2026-08-02.md
 */
(function () {
  function markersFrom(root) {
    var raw = root.getAttribute('data-faq-markers') || 'よくあるご質問';
    var out = [];
    raw.split(',').forEach(function (s) {
      var t = s.trim();
      if (t) out.push(t);
    });
    return out;
  }

  /*
   * article.content の外側で挿入される要素。
   *
   * これらは .article-template__content の中に本文の兄弟として並ぶため、
   * FAQ が記事内の最後の H2 だと、走査が本文の終端を越えてこれらを拾い、
   * 最後の答えの中に畳み込んでしまう（2026-08-17 アイスラテ記事で発生）。
   * H2 と同じく走査の終端として扱う。
   */
  var NON_CONTENT_CLASSES = ['er-article-bridge', 'series-nav', 'article-toc'];

  function isNonContent(el) {
    for (var i = 0; i < NON_CONTENT_CLASSES.length; i++) {
      if (el.classList.contains(NON_CONTENT_CLASSES[i])) return true;
    }
    return false;
  }

  function collectRange(h2) {
    var nodes = [];
    var el = h2.nextElementSibling;
    while (el && el.tagName !== 'H2' && !isNonContent(el)) {
      nodes.push(el);
      el = el.nextElementSibling;
    }
    return nodes;
  }

  function groupByQuestion(nodes) {
    var groups = [];
    var current = null;
    nodes.forEach(function (node) {
      if (node.tagName === 'H3') {
        current = { question: node, answer: [] };
        groups.push(current);
      } else if (current) {
        current.answer.push(node);
      }
    });
    return groups;
  }

  function toAccordion(group) {
    var details = document.createElement('details');
    details.className = 'article-faq__item';

    var summary = document.createElement('summary');
    summary.className = 'article-faq__question';
    summary.textContent = group.question.textContent.trim();
    details.appendChild(summary);

    var body = document.createElement('div');
    body.className = 'article-faq__answer';
    group.answer.forEach(function (node) {
      body.appendChild(node);
    });
    details.appendChild(body);

    group.question.parentNode.replaceChild(details, group.question);
  }

  function convert(h2) {
    var nodes = collectRange(h2);
    if (!nodes.length) return;

    // すでに details 形式で書かれている記事は触らない（二重変換の防止）
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].tagName === 'DETAILS') return;
    }

    var groups = groupByQuestion(nodes);
    if (!groups.length) return;

    groups.forEach(toAccordion);
    h2.classList.add('article-faq__heading');
  }

  function init() {
    var root = document.querySelector('.article-template__content');
    if (!root) return;

    var markers = markersFrom(root);
    if (!markers.length) return;

    var headings = root.querySelectorAll('h2');
    Array.prototype.forEach.call(headings, function (h2) {
      var text = (h2.textContent || '').trim();
      var hit = markers.some(function (m) {
        return text.indexOf(m) !== -1;
      });
      if (hit) convert(h2);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
